import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import { API_URL } from '../constants'
import moment from 'moment'
import { get } from 'lodash'
import { PageWrapper, XXLText, Header, Card, FlexWrapper } from '../components'
import { Link } from 'react-router-dom'

class ViewNotifications extends Component {
  state = { results: [] }
  async componentDidMount() {
    try {
      const { data } = await axios.get(`${API_URL}/Notifications`)
      this.setState({ results: data })
      console.log('data', data)
    } catch (error) {
      console.log(error)
    }
  }
  render() {
    const { results } = this.state
    return (
      <React.Fragment>
        <Header
          icon="arrowBack"
          title="View Notifications"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          color="#fff"
        />
        <PageWrapper viewPadding="0" height={'calc(100% - 10px)'} modifyPadding="0" style={{ marginTop: 60 }}>
          {results.map(item => (
            <Card padding="8px" margin="10px 0 0">
              <FlexWrapper direction="row" alignItems="center" viewPadding="10px">
                <FlexWrapper>
                  <XXLText color="#124b5f">Date: {moment(get(item.createdAt)).format('DD MMM YYYY HH:mm:ss')}</XXLText>
                  <XXLText color="#000">Title: {item.title}</XXLText>
                  <XXLText color="#000">Message: {item.message}</XXLText>
                </FlexWrapper>
                <FlexWrapper direction="column" alignItems="right">
                  <Link
                    style={{ color: '#078489', textDecoration: 'underline' }}
                    to={`/view-notification-native/${get(item, 'id', '')}`}>
                    View
                  </Link>{' '}
                  <Link style={{ color: '#078489', textDecoration: 'underline' }} to={'/add-notification-native'}>
                    Add
                  </Link>
                </FlexWrapper>
              </FlexWrapper>
            </Card>
          ))}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default ViewNotifications



// WEBPACK FOOTER //
// ./src/pages/ViewNotifications.js